import { type FC } from "react";
import styles from "./Footer.module.css";
import { PricesRecap } from "@/components/PricesRecap";
import Button from "../UI/Button";
import { Separator } from "../UI/Separator";
import InsuranceCard from "../InsuranceCard";
import { useStepStore } from "@/store";
import { STEP_ID } from "@/types";
import { useWorkflow } from "@/hooks";
import { useTranslation } from "@/i18n";

interface FooterProps {}

export const Footer: FC<FooterProps> = ({}) => {
  const { currentStep, isManualInput, isLoading } = useStepStore();
  const { canGoNext } = useWorkflow();
  const { t } = useTranslation();

  return (
    <footer className={styles.footer}>
      {currentStep?.id === STEP_ID.ADVANCED_PRESCRIPTION && isManualInput && (
        <Button
          form="prescription-form"
          type="submit"
          variant="primary"
          className={styles.button}
          disabled={isLoading}
          onClick={() => !canGoNext}
          data-element-id={canGoNext ? '' :'Prod_CartAdd'}
        >
          {isLoading ? (
            <div className={styles.loader}></div>
          ) : canGoNext ? (
            t("footer.continue")
          ) : (
            t("footer.addToCart")
          )}
        </Button>
      )}

      <section className={styles.content}>
        <Separator />
        <div className={styles.container}>
          <InsuranceCard />
          <PricesRecap />
        </div>
      </section>
    </footer>
  );
};
